import "./sessao"; // primeiro: anexa a sessão assinada em toda chamada /api/
import { createRoot } from "react-dom/client";
import App from "./App";
import AgendarPublica from "./components/AgendarPublica";
import PedidoPublico from "./components/PedidoPublico";
import "./styles.css";
import { anunciarApp } from "./pwa";

/* O manifesto e o ícone entram antes da primeira tela: instalar o app não pode
   depender de a pessoa ter entrado — e as páginas públicas (agendar, pedido)
   também são instaláveis. Ver src/pwa.ts. */
anunciarApp();

const el = document.getElementById("root");
if (!el) throw new Error("Elemento #root não encontrado");

/**
 * Rota pública da agenda: /agendar/<token>.
 *
 * Renderizada FORA do App (sem Login e sem o portão de acesso) — o token do
 * link é a credencial de quem vai marcar, exatamente como nas páginas públicas
 * do RH (triagem, DISC, clima). decodeURIComponent lança em percent-encoding
 * quebrado; nesse caso vale o valor cru e o servidor responde "link inválido",
 * em vez de a página ficar branca.
 */
function tokenDaRota(prefixo: string): string | null {
  const m = window.location.pathname.match(new RegExp("^/" + prefixo + "/([^/]+)/?$"));
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
}

const tokenAgenda = tokenDaRota("agendar");
// Acompanhamento de quem abriu uma solicitação: /pedido/<protocolo>.
const protocolo = tokenDaRota("pedido");

createRoot(el).render(
  tokenAgenda ? (
    <AgendarPublica token={tokenAgenda} />
  ) : protocolo ? (
    <PedidoPublico protocolo={protocolo} />
  ) : (
    <App />
  ),
);
